import React, { useState } from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

export const normSec = (s) => {
  const v = String(s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  return v.endsWith('section') && v.length > 7 ? v.slice(0, -7) : v;
};

const hintFor = ({ enabled, hrAll, reportsOnly }) => {
  if (!enabled) return '- Only for Supervisor / Incharge roles or Staff Attendance Approve / Reports';
  if (hrAll) return '- HR / Admin already see every section';
  return reportsOnly ? '- View these sections (none ticked = all sections)' : '- Approve / view these sections';
};

const Row = ({ checked, onChange, label, sub, testId, disabled }) => (
  <label className="flex items-center gap-2 cursor-pointer hover:bg-[#F5F1E8] p-2 rounded">
    <input type="checkbox" checked={checked} onChange={onChange} className="w-4 h-4" disabled={disabled} data-testid={testId} />
    <span className="text-sm text-[#1A1F2E] flex-1">{label}</span>
    <span className="text-[11px] text-[#8A8F9E]">{sub}</span>
  </label>
);

/** Staff Attendance approve / view scope — section names come from Staff Master (separate from WMS sections). */
export const AttendanceSectionsPicker = ({ options, value, onChange, enabled, hrAll, reportsOnly }) => {
  const [q, setQ] = useState('');
  const [pinned] = useState(() => new Set(value.map(normSec)));
  const keys = new Set(options.map((o) => o.key));
  const extras = value.filter((v) => !keys.has(normSec(v)));
  const ticked = (key) => value.some((v) => normSec(v) === key);
  const toggle = (o) => onChange(ticked(o.key) ? value.filter((v) => normSec(v) !== o.key) : [...value, o.section]);
  const shown = options.filter((o) => !q || o.section.toLowerCase().includes(q.toLowerCase()))
    .sort((a, b) => Number(pinned.has(b.key)) - Number(pinned.has(a.key)));
  return (
    <div className={enabled ? '' : 'opacity-50'} data-testid="user-satt-sections-block">
      <Label className="flex flex-wrap items-center gap-2">
        Staff Attendance Sections <span className="text-xs text-[#5A5F6E]">(from Staff Master)</span>
        <span className={`text-xs ${enabled ? 'text-amber-700' : 'text-[#5A5F6E]'}`} data-testid="user-satt-sections-hint">{hintFor({ enabled, hrAll, reportsOnly })}</span>
      </Label>
      <div className={`mt-2 border border-[#E5DFD0] rounded-lg p-3 ${enabled ? '' : 'pointer-events-none'}`}>
        <div className="flex items-center gap-2 mb-2">
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Filter sections..." className="h-8 text-sm" disabled={!enabled} data-testid="user-satt-sections-filter" />
          <span className="text-xs text-[#5A5F6E] whitespace-nowrap" data-testid="user-satt-sections-count">{value.length} ticked</span>
        </div>
        <div className="space-y-1 max-h-48 overflow-y-auto">
          {extras.map((v) => (
            <Row key={`x-${v}`} checked onChange={() => onChange(value.filter((x) => x !== v))} label={v} sub="not in Staff Master"
              testId={`user-satt-extra-${normSec(v)}`} disabled={!enabled} />
          ))}
          {shown.map((o) => (
            <Row key={o.key} checked={ticked(o.key)} onChange={() => toggle(o)} label={o.section} sub={`${o.staff_count} staff`}
              testId={`user-satt-section-${o.key}`} disabled={!enabled} />
          ))}
          {options.length === 0 && <p className="text-sm text-[#5A5F6E]" data-testid="user-satt-sections-empty">No sections in Staff Master for this site yet.</p>}
        </div>
      </div>
    </div>
  );
};

export default AttendanceSectionsPicker;
